var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.36 20.41a.98.98 0 0 0-.57-.5 1.11 1.11 0 0 0-.38-.07c-.13 0-.26.02-.39.07a.98.98 0 0 0-.56.5.98.98 0 0 0-.08.54l.19 5c0 .22.03.43.06.62.04.2.09.36.15.5.07.15.16.26.26.34.1.08.23.12.37.12a.6.6 0 0 0 .37-.12c.1-.08.19-.2.26-.33a4.41 4.41 0 0 0 .21-1.13l.18-5 .01-.12c0-.16-.03-.3-.08-.42m-1.92 9.12c.05.12.12.21.2.3a1 1 0 0 0 .32.18c.12.05.26.07.41.07.14 0 .27-.02.4-.06a.93.93 0 0 0 .52-.48.9.9 0 0 0 0-.7.91.91 0 0 0-.52-.5 1.15 1.15 0 0 0-.4-.06.98.98 0 0 0-.73.27.84.84 0 0 0-.27.63c0 .12.03.24.07.35m9.24 3.97h-16.9c-1.87 0-2.24-1.15-1.24-2.9 2.22-3.82 6.08-10.51 8.2-14.19 1.28-2.21 1.73-2.21 3 0l8.32 14.4c1.09 1.87.6 2.69-1.38 2.69",
    fill: "#FFF"
  })));
});